import Vue from 'vue';
import VueI18n from 'vue-i18n'
import general from "@/locale/nl/general.js";
import validations from "@/locale/nl/validations.js";


Vue.use(VueI18n);

const messages = {
    nl: {
        ...general,
        ...validations
    }
}

export default new VueI18n({
    locale: 'nl', // set locale
    messages, // set locale messages
})
